export const generateTextWidth = (text, font) => {
  const canvas =
    generateTextWidth.canvas ||
    (generateTextWidth.canvas = document.createElement('canvas'));
  const context = canvas.getContext('2d');
  context.font = font;
  const metrics = context.measureText(text);
  return metrics.width;
};
